import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RecentSearch from './GDGolbalFilterSelectorRecentSearchListItem';

import './GDGolbalFilterSelectorRecentSearchList.scss';

const GDGolbalFilterSelectorRecentSearchList = (props) => {
  const {
    extraClass,
    recentSearches,
    onRecentSearch,
    translations,
  } = props;

  const wrapperClass = classnames('gd-hierarchy-selector-recent-search-list', {
    [extraClass]: extraClass,
  });

  const displayRecentSearchList = recentSearches.map((search) => (

    <RecentSearch
      key={search.id}
      searchItem={search}
      onRecentSearch={onRecentSearch}
    />
  ));


  return (
    <div className={wrapperClass}>
      {displayRecentSearchList}
    </div>
  );
};

GDGolbalFilterSelectorRecentSearchList.propTypes = {
  extraClass: PropTypes.string,
  recentSearches: PropTypes.array,
  onRecentSearch: PropTypes.func,
  translations: PropTypes.object.isRequired,
};

GDGolbalFilterSelectorRecentSearchList.defaultProps = {
  extraClass: '',
  recentSearches: [],
  onRecentSearch: () => { },
};

export default GDGolbalFilterSelectorRecentSearchList;
